import { Link, useLocation } from "react-router-dom";

export const Nav = ({ variant = "cream" }) => {
  const location = useLocation();
  const isCoral = variant === "coral";
  const textColor = isCoral ? "text-white" : "text-ink";
  const borderColor = isCoral ? "border-white/20" : "border-black/10";

  return (
    <nav
      data-testid="site-nav"
      className={`w-full ${textColor} border-b ${borderColor} relative z-40`}
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-10 py-6">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3">
          <span
            className="font-cabinet font-black text-2xl md:text-[1.7rem] tracking-tighter leading-none"
            data-testid="nav-logo-wordmark"
          >
            GoneSoon<span className={isCoral ? "text-white" : "text-coral"}>.</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-10 text-sm font-satoshi font-medium">
          <Link
            to="/"
            data-testid="nav-link-home"
            className={`ed-link ${location.pathname === "/" ? "opacity-100" : "opacity-70 hover:opacity-100"}`}
          >
            Home
          </Link>
          <Link
            to="/about"
            data-testid="nav-link-about"
            className={`ed-link ${location.pathname === "/about" ? "opacity-100" : "opacity-70 hover:opacity-100"}`}
          >
            About
          </Link>
          <a
            href="#faq"
            data-testid="nav-link-faq"
            className="ed-link opacity-70 hover:opacity-100"
          >
            FAQ
          </a>
        </div>

        <Link
          to="/#waitlist"
          data-testid="nav-cta-join"
          className={`hidden md:inline-flex items-center gap-2 px-5 py-3 rounded-full text-xs font-bold uppercase tracking-[0.18em] transition-transform hover:-translate-y-0.5 ${
            isCoral ? "bg-white text-coral" : "bg-ink text-white"
          }`}
        >
          Join the list
          <span aria-hidden="true">→</span>
        </Link>
      </div>
    </nav>
  );
};

export default Nav;
